import React, {Fragment, useEffect, useState} from 'react'
import {signIn, setSignOut, saveToken} from "../authentication/actions";
import {connect} from 'react-redux';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import cookie from 'js-cookie';

const Login = (props) => {

    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    
    const signIn = () => {
        props.signIn(userName, password)
        
    };
    
    useEffect(() => {
        if (!_.isEmpty(props.signInResult)) {
            if (props.signInResult.success) {
                setError(null);
                props.setSignOut(false);
                cookie.set('tokenInfo', JSON.stringify(props.signInResult.result));
                props.saveToken(props.signInResult.result, true);
                window.location.pathname = '/'
            }
            else{
                setError(props.signInResult.result.data.message)
        setError(true)

            }
        }
    }, [props.signInResult]);

    return (
        <Fragment>
            <div className="loginPopup">
                <div className="signInBox originalBackground whiteColor">
                    <div className="backSignIn"></div>
                    <div className="normalSignIn">
                        <div className="signInTitle font-size_24 centerText organizer">ورود کاربر</div>
                        <div className="signInForm organizer">
                            <input placeholder="پست الکترونیکی" type="email" value={userName} onChange={e => setUserName(e.target.value)}/>
                            <input placeholder="رمز عبور" type="password"  value={password} onChange={e => setPassword(e.target.value)}/>
                            <div className="formActions">
                                <div className="remindMe">
                                    <label className="checkContainer">
                                        <input type="checkbox" checked="checked" />
                                        <span className="icon icon-check checkmark"></span>
                                    </label>
                                    مرا به خاطر بسپار
                                </div>
                                <div className="forget">
                                    فراموشی رمز عبور
                                </div>
                            </div>
                            <div className="organizer centerText">
                                <button type="submit" className="enter" onClick={e => signIn()}>ورود</button>
                                {error && <p className='errorText'>پست الکترونیکی یا رمز عبور نادرست است</p>}
                            </div>
                        </div>
                    </div>
                    <div className="registerHere font-size_20 centerText organizer">{error}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = ({signInResult}) => ({
    signInResult
});

export default connect(mapStateToProps, {signIn, setSignOut, saveToken})(withRouter(Login));
